import { inject } from "vue";
import { createLegacyAdapter } from "#ce/apps/SpFinder/legacy/legacy-adapter";
import { createEventsTransport } from "#ce/apps/SpFinder/legacy/events-adapter";
import { reportClientError } from "#ce/utils/error-report";
import App from "./App.ce.vue";

export {
  connectLegacyFinder,
  createLegacyNearIdentity,
  createLegacyNearProvenance,
} from "#ce/apps/SpFinder/legacy/legacy-adapter";
export { createEventsTransport } from "#ce/apps/SpFinder/legacy/events-adapter";

/** Boots an events embed after loading its configuration and template utilities. */
export async function bootEventsSearch(containerId, options) {
  try {
    const embed = await import("#ce/apps/SpFinder/legacy/events-embed");
    return await embed.bootEventsSearch(containerId, options);
  } catch (error) {
    reportClientError("Events search boot failed", {
      description: String(error?.stack ?? error),
      baseUrl: import.meta.url,
      omitPage: true,
    });
    throw error;
  }
}

/** Boots events mounts carrying server-rendered configuration within `root`. */
export async function bootStandaloneEvents(root = document) {
  const standalone = await import("#ce/apps/SpFinder/legacy/events-standalone");
  return standalone.bootStandaloneEvents(root, bootEventsSearch);
}

function loadFinderLegacy() {
  return import("#ce/apps/SpFinder/legacy/doctor-finder");
}

// A finder nested in another inherits the outer app's provides, which hold these same values.
// Providing them again would only make Vue warn about the overwrite.
function provideUnlessInherited(app, key, value) {
  if (app.runWithContext(() => inject(key, null)) === null) {
    app.provide(key, value);
  }
}

const legacyRegistration = {
  install(app) {
    provideUnlessInherited(app, "createFinderLegacyAdapter", createLegacyAdapter);
    provideUnlessInherited(app, "bootFinderEvents", createEventsTransport);
    provideUnlessInherited(app, "loadFinderLegacy", loadFinderLegacy);
  },
};

export function setup() {
  return {
    component: App,
    plugins: [legacyRegistration],
  };
}
